export const numberMask = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  return value;
};
